const toRequest = request => request;

export default toRequest;
